import { caseDetailSpan } from 'utils'
import { replaceInitialValues } from 'utils/tinyMCE/replaceInitialValues'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import { insertTemplate } from '../insertMenu/insertTemplate'
import { formatCityStatePostal } from 'utils/tinyMCE/formatCityStatePostal'

export const handleFuneralHome = (
  editor,
  funeralHomeDetails,
  templates,
  dateFormat,
  selectedTheme,
) => {
  const themeStyles = getThemeStylesForTemplate({ selectedTheme, editor })

  // Build smart address strings using extended formatCityStatePostal utility
  const buildCityState = () => {
    return formatCityStatePostal(
      { city: funeralHomeDetails.city, state: funeralHomeDetails.state },
      { useCaseDetailSpan: true, keyPrefix: 'funeralHomeDetails' },
    )
  }

  const buildFullAddress = () => {
    const parts = []
    if (funeralHomeDetails.address?.trim()) {
      parts.push(caseDetailSpan('funeralHomeDetails.address'))
    }
    const cityStateZip = formatCityStatePostal(
      {
        city: funeralHomeDetails.city,
        state: funeralHomeDetails.state,
        postal: funeralHomeDetails.zip_code,
      },
      {
        useCaseDetailSpan: true,
        keyPrefix: 'funeralHomeDetails',
        postalFieldName: 'zip_code',
      },
    )
    if (cityStateZip) parts.push(cityStateZip)
    return parts.join(', ')
  }

  const funeralHomeOption1 = replaceInitialValues(
    `
    <div style="${themeStyles}">
      <p>${caseDetailSpan(`funeralHomeDetails.name`)}</p>
      <p>${buildCityState()}</p>
    </div>
  `,
    { funeralHomeDetails },
  )

  const funeralHomeOption2 = replaceInitialValues(
    `
    <div style="${themeStyles}">
      <p>${caseDetailSpan(`funeralHomeDetails.name`)}</p>
      <p>${buildFullAddress()}</p>
    </div>
  `,
    { funeralHomeDetails },
  )

  const funeralHomeOption3 = replaceInitialValues(
    `
    <div style="${themeStyles}">
      <p>${caseDetailSpan(`funeralHomeDetails.name`)}</p>
      <p>${buildFullAddress()}</p>
      <p>${caseDetailSpan(`funeralHomeDetails.email_address`)}</p>
    </div>
  `,
    { funeralHomeDetails },
  )

  const funeralMenuOption = [
    funeralHomeOption1,
    funeralHomeOption2,
    funeralHomeOption3,
  ]

  funeralMenuOption.forEach((option, index) => {
    templates.push({
      type: 'menuitem',
      text: `Funeral Home option ${index + 1}`,
      onAction: () => insertTemplate(editor, option),
    })
  })
}

export default handleFuneralHome
